import InputFile from '@formComponents/InputFile';
import React from 'react';

export const renderFile = ({
    input,
    label,
    type,
    options,
    placeholder,
    meta: { touched, error },
}) => {

    return (
        <React.Fragment>
            <InputFile
                {...input}
                options={options}
                label={label}
                placeholder={placeholder}
            />

            {touched && error && <span>{error}</span>}
        </React.Fragment>
    );
};
